
import Vue from 'vue';
import { mapActions, mapState } from 'vuex';

import { SendNewDeviceEmailParams } from '@/api/endpoints/practices';
import { getEmailEditorOptions } from '@/utils/email';

import { PracticesActions } from '@/store/modules/practices/types';
import Email from '@/store/modules/settings/email';

import FormInput from '@/components/controls/form-input.vue';
import Modal from '@/components/layout/modal.vue';
import MarkdownEditor from '@/components/controls/markdown-editor.vue';
import SubmitButton from '@/components/controls/submit-button.vue';

export default Vue.extend({
  name: 'SendNewDeviceEmailModal',
  props: {
    id: {
      type: Number,
      required: true,
    },
    productId: {
      type: Number,
      required: true,
    },
    languageCode: {
      type: String,
      required: true,
    },
  },
  $_veeValidate: {
    validator: 'new',
  },
  components: {
    FormInput,
    Modal,
    MarkdownEditor,
    SubmitButton,
  },
  data() {
    return {
      subject: '',
      body: '',
      button: '',
      help: '',
      sentTo: undefined as undefined | 'user' | 'admin',
      replyTo: undefined as undefined | string,
    };
  },
  computed: {
    ...mapState('practices', {
      isSendingNewDeviceEmail: 'sendingNewDeviceEmail',
    }),
    ...mapState('settings', ['emails']),
    newDeviceEmail() {
      return (this.emails as Email[]).find((email) => email.key === 'new-device-added');
    },
    editorOptions() {
      return getEmailEditorOptions(this.newDeviceEmail);
    },
  },
  methods: {
    ...mapActions('practices', {
      sendNewDeviceEmail: PracticesActions.SEND_NEW_DEVICE_EMAIL,
    }),
    getSendNewDeviceEmailParams(): SendNewDeviceEmailParams {
      return {
        id: this.id,
        product_id: this.productId,
        send_to_admin: false,
        subject: this.subject,
        body: this.body,
        button: this.button,
        help: this.help,
        reply_to: this.replyTo,
      };
    },
    sendToUser() {
      this.sentTo = 'user';
      this.sendNewDeviceEmail(this.getSendNewDeviceEmailParams()).then(() => this.$emit('close'));
    },
  },
  watch: {
    languageCode: {
      handler(value: string, prevValue: string) {
        const email = this.newDeviceEmail as Email | undefined;

        if (!email) {
          return;
        }

        this.subject =
          typeof email.translations.subject[value] !== 'undefined' ? email.translations.subject[value] : email.subject;
        this.body = typeof email.translations.body[value] !== 'undefined' ? email.translations.body[value] : email.body;
        this.button =
          typeof email.translations.button[value] !== 'undefined' ? email.translations.button[value] : email.button;
        this.help = typeof email.translations.help[value] !== 'undefined' ? email.translations.help[value] : email.help;
      },
      immediate: true,
    },
  },
});
